// src/components/TableRemitos.jsx
import React, { useEffect, useState, useCallback } from "react";
import { Table } from "react-bootstrap";
import { getRemitos, deleteRemito, getRemitoById } from "../helpers/rutaRemitos";
import ModalFormRemito from "../components/ModalFormRemito";

const COLS = {
  acciones: 100, nro: 90, fecha: 120,
  kg: 110, precio: 120,
  persona: 220,
  variedad: 180,
  money: 140, dtv: 160,
  lote: 160,
  nota: 260,
  bool: 90,
};



const trunc = { overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" };
// const fmtDate = (d) => (d ? new Date(d).toLocaleDateString("es-AR") : "-");
const fmtDate = (d) => {
  if (!d) return "-";
  const date = new Date(d);
  const year  = date.getUTCFullYear();
  const month = String(date.getUTCMonth() + 1).padStart(2, "0");
  const day   = String(date.getUTCDate()).padStart(2, "0");
  return `${day}/${month}/${year}`;  // formato dd/mm/aaaa
};


const fmtMoney = (n) => Number(n || 0).toLocaleString("es-AR", { minimumFractionDigits: 2 });

const TableRemitos = () => {
  const [state, setState] = useState({ remitos: [], loading: true, error: "" });
  const [remitoSel, setRemitoSel] = useState(null);
  const [showEdit, setShowEdit] = useState(false);

  const load = useCallback(async () => {
    try {
      const list = await getRemitos();
      const arr = Array.isArray(list) ? list : (list?.remitos || []);
      arr.sort(
        (a, b) =>
          (b.codrem || 0) - (a.codrem || 0) ||
          new Date(b.fecha) - new Date(a.fecha)
      );
      setState({ remitos: arr, loading: false, error: "" });
    } catch (e) {
      setState((s) => ({ ...s, loading: false, error: e?.message || "Error al cargar remitos" }));
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const handleCloseEdit = useCallback(() => {
    setShowEdit(false);
    setRemitoSel(null);
    // refrescar lista
    setTimeout(() => load(), 0);
  }, [load]);

  // ⚠️ Trae el remito primero y recién entonces abre el modal
  const onEdit = useCallback(async (id) => {
    try {
      setRemitoSel(null);
      const resp = await getRemitoById(id);
      if (resp?.ok && resp.remito) {
        setRemitoSel(resp.remito);
        setShowEdit(true);
      } else {
        console.error("❌ getRemitoById:", resp?.error || resp);
        alert("No se pudo cargar el remito.");
      }
    } catch (e) {
      console.error(e);
      alert("Error de red al cargar el remito.");
    }
  }, []);

  const onDelete = useCallback(async (id) => {
    if (!window.confirm("¿Borrar (lógico) este remito?")) return;
    try { await deleteRemito(id); load(); } catch (e) { console.error(e); }
  }, [load]);

  if (state.loading) return <div className="p-3">Cargando remitos…</div>;
  if (state.error)   return <div className="p-3 text-danger">{state.error}</div>;

  return (
    <div className="table-container">
      <div className="d-flex justify-content-between align-items-center my-3">
        <h5 className="m-0">Gestión de Remitos</h5>
      </div>

      <Table striped bordered hover style={{ tableLayout: "fixed", width: "100%" }}>
        <thead>
          <tr>
            <th style={{ width: COLS.acciones }}>Acciones</th>
            <th style={{ width: COLS.nro }}>Remito</th>
            <th style={{ width: COLS.fecha }}>Fecha</th>
            <th style={{ width: COLS.persona }}>Proveedor</th>
            <th style={{ width: COLS.persona }}>Cliente</th>
            <th style={{ width: COLS.kg }}>KG Campo</th>
            <th style={{ width: COLS.kg }}>KG Recibidos</th>
            <th style={{ width: COLS.kg }}>Diferencia</th>
            <th style={{ width: COLS.precio }}>Precio Compra</th>
            <th style={{ width: COLS.precio }}>Precio Venta</th>
            <th style={{ width: COLS.persona }}>Transporte</th>
            <th style={{ width: COLS.persona }}>Chofer</th>
            <th style={{ width: COLS.lote }}>Lote</th>
            <th style={{ width: COLS.variedad }}>Variedad</th>
            <th style={{ width: COLS.money }}>Total Compra</th>
            <th style={{ width: COLS.money }}>Total Venta</th>
            <th style={{ width: COLS.money }}>Comisión</th>
            <th style={{ width: COLS.dtv }}>Nro DTV Compra</th>
            <th style={{ width: COLS.dtv }}>Nro DTV Venta</th>
            <th style={{ width: COLS.bool, textAlign: "center" }}>Factura</th>
            <th style={{ width: COLS.nota }}>Notas</th>
          </tr>
        </thead>
        <tbody>
          {state.remitos.length === 0 ? (
            <tr><td colSpan={21} className="text-center">No hay remitos.</td></tr>
          ) : state.remitos.map((r) => (
            <tr key={r._id}>
              <td style={{ whiteSpace: "nowrap" }}>
                <div style={{ display: "flex", gap: 8, justifyContent: "center" }}>
                  <button className="btn btn-primary" onClick={() => onEdit(r._id)}>
                    <i className="fa fa-pencil-square-o" />
                  </button>
                  {/* <button className="btn btn-danger" onClick={() => onDelete(r._id)}>
                    <i className="fa fa-trash-o" />
                  </button> */}
                </div>
              </td>
              <td>{r.codrem}</td>
              <td>{fmtDate(r.fecha)}</td>
              <td style={trunc}>{r.proveedor?.razonsocial || "-"}</td>
              <td style={trunc}>{r.cliente?.razonsocial || "-"}</td>
              <td>{r.kgCampo}</td>
              <td>{r.kgRecibido}</td>
              <td>{r.diferencia}</td>
              <td>{fmtMoney(r.precioCompra)}</td>
              <td>{fmtMoney(r.precioVenta)}</td>
              <td style={trunc}>{r.transporte?.transporte || "-"}</td>
              <td style={trunc}>{r.chofer?.nombre || "-"}</td>
              <td style={{ ...trunc, textAlign: "left" }}>
                {r.lote
                  ? (r.lote.codlote != null ? `#${r.lote.codlote} - ${r.lote.lote}` : r.lote.lote)
                  : "—"}
              </td>
              <td style={trunc}>{r.variedad || "-"}</td>
              <td>{fmtMoney(r.totalCompra)}</td>
              <td>{fmtMoney(r.totalVenta)}</td>
              <td>{fmtMoney(r.comision)}</td>
              <td style={trunc}>{r.nroDTVCompra || "-"}</td>
              <td style={trunc}>{r.nroDTVVenta || "-"}</td>
              <td style={{ width: COLS.bool, textAlign: "center" }}>
                {r.factura ? "✅" : "—"}
              </td>
              <td style={trunc}>{r.nota || "-"}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Modal: sólo se muestra cuando ya tenemos remitoSel */}
      <ModalFormRemito
        show={showEdit}
        remito={remitoSel}
        onClose={handleCloseEdit}
      />
    </div>
  );
};

export default TableRemitos;
